import { render } from "./ColumnDrilldown.vue?vue&type=template&id=6beaf490"
import script from "./ColumnDrilldown.vue?vue&type=script&lang=js"
export * from "./ColumnDrilldown.vue?vue&type=script&lang=js"

import "./ColumnDrilldown.vue?vue&type=style&index=0&id=6beaf490&lang=scss"
script.render = render

export default script